const Demo6Content6 = () => {
    return (
        <section id="content-6" className="content-6 wide-60 content-section division">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-md-6 col-lg-5">
                        <div className="txt-block left-column wow fadeInRight">
                            <div className="txt-box mb-30">
                                <h5 className="h5-lg">Built for Collaboration</h5>
                                <p className="p-lg">
                                    Invite your entire team. Translators, editors, and project managers can all work together in real-time, leaving comments and resolving issues instantly.
                                </p>
                            </div>
                            <div className="txt-box">
                                <h5 className="h5-lg">Simple, Transparent Pricing</h5>
                                <ul className="simple-list">
                                    <li className="list-item">
                                        <p className="p-lg">
                                            No hidden fees. Pay only for what you translate, with volume discounts for large projects.
                                        </p>
                                    </li>
                                    <li className="list-item">
                                        <p className="p-lg">
                                            Unlimited seats for your team. We don't charge per user, so you can grow without limits.
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-7">
                        <div className="img-block right-column wow fadeInLeft">
                            <img className="img-fluid" src="/images/demo6/img-19.png" alt="content" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Content6;
